<template>
  <div class="glo_btnList_right">
    <el-button
      class="glo_bgcMainColor"
      @click="queryBtn_ok"
      icon="el-icon-search"
      >查询</el-button
    >
    <el-tooltip v-if="isShowClear" content="重置查询条件" placement="top">
      <div class="textBtn" @click="clerBtns">重置</div>
    </el-tooltip>
    <el-tooltip v-if="showMoreBtns" content="展开收起更多条件" placement="top">
      <div class="textBtn" @click="moreParam">{{ MoreConditions }}</div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    MoreConditions: {
      typeof: String,
      default: "",
    },
    showMoreBtns: {
      typeof: Boolean,
      default: true,
    },
    isShowClear: {
      typeof: Boolean,
      default: true,
    },
  },
  methods: {
    moreParam() {
      this.$emit("moreParam");
    },
    queryBtn_ok() {
      this.$emit("queryBtn_ok");
    },
    clerBtns() {
      this.$emit("clerBtns");
    },
  },
};
</script>

<style>
</style>